import { Badge, Modal } from "flowbite-react";
import { useContext } from "react";
import { IAppContextState, AppContext } from "../../../App";
import { Link } from "react-router-dom";
import { HuntImageGallery } from "../../../components/image-gallery/hunt-gallery";

export const HuntModalData = () => {
  const { huntModalState } = useContext<IAppContextState | any>(AppContext);
  const [isOpenHuntModal, setOpenHuntModal] = huntModalState;
  return (
    <Modal
      size={"5xl"}
      position={"top-center"}
      show={isOpenHuntModal}
      onClose={() => setOpenHuntModal(false)}
    >
      <Modal.Header>
        Agency <b>Hunt</b> Homepage
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-wrap">
          <div className="md:w-[50%] w-full pe-2">
            <HuntImageGallery />
          </div>
          <div className="md:w-[50%] w-full ps-2 md:mt-0 mt-6 flex flex-col justify-between">
            <div>
              <h3 className="font-bold text-xl">
                Project name: <span className="text-gray-600">Hunt home</span>
              </h3>
              <p className="mt-4 mb-2 text-md text-[15px]">Tech used:</p>
              <div className="flex">
                <Badge color="red" className="me-2 my-1">
                  HTML
                </Badge>
                <Badge color="yellow" className="me-2 my-1">
                  jQuery
                </Badge>
                <Badge color="blue" className="me-2 my-1">
                  Bootstrap
                </Badge>
                <Badge color="pink" className="my-1">
                  SCSS
                </Badge>
              </div>
              <div className="mt-5 mb-2 ">
                <p className="font-semibold">Description:</p>
                <div className="text-[15px]">
                  <ul className="list-disc mt-4 ms-5">
                    <li>
                      This website is a demo design for Agency based Company's
                      landing page.
                    </li>
                    <li>
                      Based on Bootstrap, javaScript and jQuery for dynamic and
                      mobile friendly UI experiences
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="mt-10">
              <Link
                target="_blank"
                rel="noreferrer"
                to="https://hunt-home.netlify.app/"
                className="text-gray-800 hover:text-gray-950 hover:underline"
              >
                Go to website
              </Link>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
